import  usePartner from './usePartner';
export default usePartner
